import React, { useEffect, useState } from 'react';

const Privacy = () => {
  const [footer, setFooter] = useState('');

  useEffect(() => {
    fetch('/footer.html')
      .then(response => response.text())
      .then(data => setFooter(data))
      .catch(error => console.error('Error loading footer:', error));
  }, []);

  return (
    <div style={styles.content}>
      <main style={styles.main}>
        <h1>Privacy Policy</h1>
        <pre style={styles.pre}>
{`Effective Date: January 1, 2026

The Scrupulous Principle Ltd., operating under the Skroop.org brand ("we," "us," "our"), is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and protect personal information when you use our Services.

1. Information We Collect
a. Information You Provide

We may collect:

-Name, email address, phone number, and mailing address
-Account credentials
-Payment-related information (processed by third-party payment providers)
-Communications and support inquiries

b. Information Collected Automatically

We may collect:

-Device identifiers, IP address, and operating system
-Usage data and interaction logs
-Diagnostic and performance data

c. Information from Third Parties

We may receive information from payment processors, app platforms, or service providers related to transactions, subscriptions, or account authentication.

2. How We Use Your Information

We use personal information to:

-Provide and operate the Services
-Process transactions and subscriptions
-Communicate with users
-Improve functionality and security
-Comply with legal obligations

Legal Bases (GDPR)
-Consent
-Contractual necessity
-Legitimate interests
-Legal obligations

3. Payments and Platform Transactions

When you make purchases through a mobile application or platform, transaction handling, billing details, and refund eligibility are governed by that platform's policies. We receive only the information necessary to provide access and maintain your account.

4. Sharing of Information

We do not sell personal data. We may share information:

-With service providers under confidentiality obligations
-To comply with legal requirements
-With your consent

5. Data Security

We implement reasonable technical and organizational safeguards. No system is completely secure, and we cannot guarantee absolute security.

6. Data Retention

We retain personal data only as long as necessary for the purposes described, unless longer retention is required by law.

7. Your Rights

You may request:

-Access, correction, or deletion of your data
-Restriction or objection to processing
-Data portability
-Withdrawal of consent

California Residents

We comply with CCPA/CPRA requirements and do not sell or share personal data.

Requests may be sent to virtue@skroop.org.

8. International Transfers

Your data may be processed in the United States. Where required, appropriate safeguards are used.

9. Children's Privacy

The Services are designed for a general audience. We do not knowingly collect personal information from children under 13 without verifiable parental consent. Certain features may require adult participation.

10. Third-Party Links

We are not responsible for third-party privacy practices.

11. Changes to This Policy

Updates will be posted with a revised Effective Date. Continued use constitutes acceptance.

12. Contact Us

The Scrupulous Principle Ltd.
1178 Broadway, 3rd Floor Box #543
New York, NY 10001
virtue@skroop.org`}
        </pre>
      </main>
      <div dangerouslySetInnerHTML={{ __html: footer }} />
    </div>
  );
};

const styles = {
  content: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    padding: 20,
    maxWidth: 800,
    margin: '0 auto'
  },
  main: {
    flex: 1,
    paddingBottom: 80
  },
  pre: {
    whiteSpace: 'pre-wrap',
    fontFamily: 'Arial, sans-serif',
    lineHeight: 1.6
  }
};

export default Privacy;
